import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DarkModeToggle } from './DarkModeContext';
import { ROLE_DEFAULTS } from './roleDefaults';

// Sign-out button with the standard gold hover used across the portal topbars.
function NavBtn({ children, onClick }) {
  const [hovered, setHovered] = React.useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? 'rgba(201,168,76,0.15)' : 'transparent',
        color: hovered ? '#C9A84C' : '#fff',
        border: `0.5px solid ${hovered ? '#C9A84C' : 'rgba(255,255,255,0.25)'}`,
        borderRadius: '6px', padding: '6px 12px', fontSize: '13px',
        cursor: 'pointer', transition: 'all 0.15s', fontWeight: hovered ? 500 : 400,
      }}
    >
      {children}
    </button>
  );
}

// Standard navy top bar for full-page form views (New Starter / Leaver forms rendered
// outside a dashboard shell). Mirrors the topbar used by ComplianceView / StaffView /
// EmployeeView so the Enko Portal branding + Sign out stay visible while a form is open.
export function FormTopBar({ subtitle, onLogout, role, onLogoClick }) {
  const navigate = useNavigate();
  const goHome = () => {
    // Callers whose sub-view is local component state rather than a route (e.g. EmployeeView's
    // New Starter/Sponsor sub-forms) pass onLogoClick to close that state first - navigate() alone
    // is a no-op when the target route equals the current one, which is the case there.
    if (onLogoClick) onLogoClick();
    navigate(ROLE_DEFAULTS[(role || 'employee').toLowerCase()] || '/employee');
  };
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 24px', backgroundColor: '#1a2744', borderBottom: '0.5px solid rgba(255,255,255,0.1)', position: 'sticky', top: 0, zIndex: 20 }}>
      <button
        type="button"
        style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', background: 'none', border: 'none', padding: 0, font: 'inherit', textAlign: 'left' }}
        onClick={goHome}
        title="Go to dashboard"
      >
        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px', border: '1.5px solid #C9A84C', color: '#C9A84C', borderRadius: '6px', fontSize: '15px', fontWeight: '700' }}>Σ</span>
        <span style={{ display: 'block' }}>
          <span style={{ fontSize: '13px', fontWeight: 500, color: '#fff' }}>Enko Portal</span>
          {subtitle && <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.6)' }}> · {subtitle}</span>}
        </span>
      </button>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <DarkModeToggle />
        {onLogout && <NavBtn onClick={onLogout}>Sign out</NavBtn>}
      </div>
    </div>
  );
}

export default FormTopBar;
